<template>
	<div class="status-container">
		<v-img v-if="questionStatus === 'NotLoggedIn'" class="status-img" aria-hidden="true" max-height="60" contain :src="require('@/assets/partial-32.png')" title="NotLoggedIn"></v-img>
		<v-img v-if="questionStatus === 'NotStarted'" class="status-img" aria-hidden="true" max-height="60" contain :src="require('@/assets/notStarted.png')" title="NotStarted"></v-img>
		<v-img v-if="questionStatus === 'Complete'" class="status-img" aria-hidden="true" max-height="60" contain :src="require('@/assets/check-64.png')" title="Complete"></v-img>
		<v-img v-if="questionStatus === 'InProgress'" class="status-img" aria-hidden="true" max-height="60" contain :src="require('@/assets/partial-16.png')" title="InProgress"></v-img>
		<v-img v-if="questionStatus === 'Errors'" class="status-img" aria-hidden="true" max-height="60" contain :src="require('@/assets/error-64.png')" title="Errors"></v-img>
		<v-img v-if="questionStatus === 'Warnings'" class="status-img" aria-hidden="true" max-height="60" contain :src="require('@/assets/warning-64.png')" title="Warnings"></v-img>
	</div>
</template>

<script>
/**
 * Reactive question status icon. Bind the question id to the component and it will retrieve the status from the store
 * and display the appropriate icon.
 */
export default {
	name: 'QuestionStatusIcon',
	props: {
		questionId: null
	},
	mounted () {
    return this.$store.getters['validation/questionStatus'](this.questionId);
  },
	computed: {
		questionStatus () {
			return this.$store.getters['validation/questionStatus'](this.questionId);
		}
	}
}
</script>

<style scoped>
	.status-img {
		width: 16px;
		height: 16px;
	}

	/* larger status image on accordion header */
	button .status-img {
		width: 20px;
		height: 20px;
	}

</style>
